import React, { useState } from "react";
import clsx from "clsx";
import styles from "./TrancheApprovalSend.module.css";
import { LuExternalLink } from "react-icons/lu";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import ActivityCard from "../ApprovedTranch/ActivityCard";
import { showNotification } from "../../service/showNotification";
import { sendTrancheForApproval } from "../../service/api";
import { useHistory } from "react-router-dom";
import { TrancheBotV2Status } from "../../utils/constant";
import { Button } from "react-bootstrap";
import { FaArrowLeftLong } from "react-icons/fa6";

const TrancheApprovalSend = ({ trancheData, onApprovalSent }) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSendForApproval = async (trancheId) => {
    try {
      setLoading(true);
      await sendTrancheForApproval(trancheId);
      showNotification("success", "Tranche sent for approval!");
      onApprovalSent(trancheId);
    } catch (error) {
      console.error("Error sending tranche for approval:", error);
      showNotification("error", "Failed to send tranche for approval.");
    } finally {
      setLoading(false);
    }
  };

  const handleFindNewAssets = () => {
    console.log("Finding new assets...");
    history.push("/tranche-bot-v2");
  };

  const handleAssetClick = (asset) => {
    history.push({
      pathname: "/assets-v2",
      state: {
        id: asset?.assetId,
      },
    });
  };

  return (
    <div className={styles.pageContainer}>
      <main className={styles.mainGrid}>
        {/* Left column: success card */}
        <div className={styles.leftColumn}>
          <div className="d-flex w-100 justify-content-start align-items-center mb-4 text-start">
            <button
              className={styles.backButton}
              onClick={() => history.goBack()}
            >
              <FaArrowLeftLong /> Back
            </button>
          </div>

          <div className={styles.contentWrapper}>
            <IoCheckmarkCircleOutline
              className={styles.successIcon}
              size={60}
            />

            <h1 className={styles.title}>Tranche Created Successfully!</h1>
            <p className={styles.subtitle}>
              The following tranche has been created in Zoho CRM and is ready
              for approval.
            </p>

            <div className={styles.card}>
              {/* New Tranche Record Section */}
              <div>
                <p className={styles.sectionHeader}>New Tranche Record</p>
                <a className={styles.trancheLink}>{trancheData?.trancheName}</a>
                <p className={styles.statusText}>
                  Status: <strong>{trancheData?.status}</strong>
                </p>
              </div>

              <hr className={styles.divider} />

              {/* Linked Assets Section */}
              <div>
                <h2 className={styles.sectionTitle}>Linked Assets</h2>
                {trancheData?.selectedAssets?.length > 0 ? (
                  <ul className={styles.list}>
                    {trancheData.selectedAssets.map((asset, index) => (
                      <li
                        key={index}
                        className={styles.listItem}
                        onClick={() => handleAssetClick(asset)}
                      >
                        <span>
                          {asset.assetId} - ${asset?.price?.toLocaleString()}
                        </span>
                        <LuExternalLink size={18} />
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No linked assets</p>
                )}
              </div>

              <hr className={styles.divider} />

              {/* Final Summary Section */}
              <div>
                <h2 className={styles.sectionTitle}>Final Summary</h2>
                <div className={styles.summaryList}>
                  <div className={styles.summaryItem}>
                    <p>Total Equity:</p>
                    <p className={styles.summaryValue}>
                      $
                      {trancheData?.totalPurchaseAmount?.toLocaleString() ||
                        "0"}
                    </p>
                  </div>
                  <div className={styles.summaryItem}>
                    <p>ITC %:</p>
                    <p className={styles.summaryValue}>
                      {trancheData?.totalItcPercent || 0}%
                    </p>
                  </div>
                  <div className={`${styles.summaryItem} ${styles.dangerText}`}>
                    <p>EC Not Utilized:</p>
                    <p className={clsx(styles.summaryValue, styles.dangerText)}>
                      {trancheData?.ecToDeploy !== undefined ? (
                        <>
                          $
                          {(
                            (trancheData.totalPurchaseAmount || 0) -
                            trancheData.ecToDeploy
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}{" "}
                          (
                          {(
                            (((trancheData.totalPurchaseAmount || 0) -
                              trancheData.ecToDeploy) /
                              trancheData.ecToDeploy) *
                            100
                          ).toFixed(2)}
                          %)
                        </>
                      ) : (
                        "0"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className={styles.buttonGroup}>
              <Button
                variant="primary"
                className={clsx(styles.actionButton)}
                onClick={() => handleSendForApproval(trancheData._id)}
                disabled={
                  loading || trancheData.status !== TrancheBotV2Status.ACTIVE
                }
              >
                {loading ? "Sending..." : "Send for Approval"}
              </Button>
              <button
                className={clsx(styles.actionButton, styles.secondaryButton)}
                onClick={handleFindNewAssets}
              >
                Find New Assets
              </button>
            </div>
          </div>
        </div>

        <div className={styles.activityCard}>
          <ActivityCard />
        </div>
      </main>
    </div>
  );
};

export default TrancheApprovalSend;
